import { NestedValidation } from '@/shared/forms/validation-properties'
import { FormArray, FormGroup } from '@/shared/forms/form-group'
import { Validation } from '@/shared/forms/validation'
import { ArrayKeys } from '@/shared/forms/array-keys'

export class FormGroupImpl<Form> implements FormGroup<Form> {
  /**
   * The validation state of this form group
   */
  public validations: NestedValidation<Form>

  /**
   * The value of this form group
   */
  public value: Form

  constructor(validations: NestedValidation<Form>, value: Form) {
    this.validations = validations
    this.value = value
  }

  public array<Key extends ArrayKeys<Form>>(name: Key): FormArray<Form[Key]> {
    const validation = this.validations[name] as any

    return {
      validations: validation,
      value: this.value[name],
    }
  }

  public field<Key extends keyof Form>(name: Key): Validation<Form[Key]> {
    const field: Validation<Form[Key]> = (this.validations as any)[name]

    return (
      field ||
      ({
        $dirty: false,
        $invalid: false,
      } as any)
    )
  }

  public group<Key extends keyof Form>(name: Key): FormGroup<Form[Key]> {
    return new FormGroupImpl(this.validations[name] as any, this.value[name])
  }
}
